import { render } from "./Users.vue?vue&type=template&id=3684e9a8&scoped=true"
import script from "./Users.vue?vue&type=script&lang=js"
export * from "./Users.vue?vue&type=script&lang=js"

import "./Users.vue?vue&type=style&index=0&id=3684e9a8&scoped=true&lang=css"

import exportComponent from "/home/gp/git/git.glitchedpolygons.ch/locales.glitchedpolygons.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3684e9a8"]])

export default __exports__